/* Control Pad Actions*/
export const POWER_TOGGLE = 'POWER_TOGGLE';
export const BANK_TOGGLE = 'BANK_TOGGLE';
export const CHANGE_VOLUME = 'CHANGE_VOLUME';

/* Button Pad Actions */
export const DISPLAY_BUTTON_NAME = 'DISPLAY_BUTTON_NAME';
